export default {
   branches: {
      allBranches: []
   }
}
